import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Card } from './models/card.model';

export interface CardState extends EntityState<Card> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'Card', idKey: 'ACN', cache: { ttl: 20000 } })
export class CardStore extends EntityStore<CardState> {
  constructor() {
    super();
  }
}
